import React, {Component, PropTypes} from 'react'
import { connect } from 'react-redux'
import {
  LeadCaptureForm,
} from '../../components'

@connect(
  state => ({
    timerExpired: state.timer.expired,
    count: state.pageCount.count,
  })
)
export default class LeadCaptureFormManager extends Component {
  static propTypes = {
    timerExpired: PropTypes.bool,
    count: PropTypes.int,
  }
  static defaultProps = {
    timerExpired: false,
    count: 0,
  };
  constructor(props) {
    super(props);
    const MULTIPLE_PAGES_THRESHOLD = 6
    const PAGE_THRESHOLDS = []
    for (let n = 1; n <= 20; n++) {
      PAGE_THRESHOLDS.push(3 * n * n - 3 * n + MULTIPLE_PAGES_THRESHOLD);
    }
    this.state = {
      modalDismissed: false,
      noCookieFound: false,
      MULTIPLE_PAGES_THRESHOLD,
      PAGE_THRESHOLDS,
    };
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentDidMount() {
    const cookieFound = document.cookie
      .split(';')
      .some(c => c.trim().startsWith('ayk_iyv_lead_form_submitted='));

    if (!cookieFound) {
      this.setState({ noCookieFound: true });
    }
  }

  componentWillReceiveProps(props) {
    /**
     * If MULTIPLE_PAGES_THRESHOLD is set to 6, popups appear at:
     * - 6  d1  d2 
     * - 12 +6  +6
     * - 24 +12 +6
     * - 42 +18 +6
     * - 66 +24 +6
     * - 96 +30 +6
     * 
     */ 
    if (this.state.PAGE_THRESHOLDS.includes(props.count)) {
      const cookieFound = document.cookie
        .split(';')
        .some(c => c.trim().startsWith('ayk_iyv_lead_form_submitted='));
      if (!cookieFound) {
        this.setState({modalDismissed: false})
      }
    }
  }

  handleDismiss() {
    this.setState({ modalDismissed: true });
  }

  render() {
    if (!this.state.noCookieFound) {

    }
    if (
      (this.props.timerExpired || this.props.count >= this.state.MULTIPLE_PAGES_THRESHOLD)
      && this.state.noCookieFound
      && !this.state.modalDismissed
    ) { 
      return (
        <LeadCaptureForm
          onDismiss={this.handleDismiss}
          cycle={Math.floor(this.props.count / this.state.MULTIPLE_PAGES_THRESHOLD)}
        />
      )
    }
    return null
  }
}

